import { student } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IStudentCourceDetails } from "../../models/student/studentCourceDetail";

export default new (class StudentCourceDetailService {
  public getCourceDetails = async (
    semesterId?: number
  ): Promise<IApiResponse<IStudentCourceDetails>> => {
    try {
      const endPoint = urlBinder(student.STUDENT_COURCE_DETAIL, [`${semesterId}`,]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IStudentCourceDetails>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IStudentCourceDetails>;
      } else {
        throw error;
      }
    }
  };
})();
